module.exports = __webpack_public_path__ + "img/svg/competition-card-hover.796a203845f6fadeaf8a122732f49554.svg";